export const resolveEventOwnerId = (userRef) => {
    if (userRef == null || userRef === '') {
        return '';
    }
    if (typeof userRef === 'string') {
        return userRef;
    }
    if (typeof userRef === 'object') {
        if (userRef._id != null) {
            return String(userRef._id);
        }
        if (typeof userRef.toString === 'function') {
            const asString = userRef.toString();
            if (asString && asString !== '[object Object]') {
                return asString;
            }
        }
    }
    return String(userRef);
};

export const isOwnEvent = (event, loggedInUser) => {
    if (loggedInUser == null || loggedInUser._id == null) {
        return false;
    }
    return resolveEventOwnerId(event?.user) === String(loggedInUser._id);
};

export const resolveOwnerId = resolveEventOwnerId;

export const isOwnJob = (job, loggedInUser) => {
    if (loggedInUser == null || loggedInUser._id == null) {
        return false;
    }
    return resolveOwnerId(job?.user) === String(loggedInUser._id);
};
